<template>
  <div>
    <el-table
      @sort-change="sortChange"
      :data="centrosCustosResponse.centrosCustos"
      style="width: 100%"
      class="p-table"
      stripe
      border
      size="mini"
    >
      <el-table-column
        prop="nome"
        label="Centro de Custo"
        min-width="80"
        sortable
      >
      </el-table-column>

      <el-table-column
        prop="emUso"
        label="Em uso nos últimos 30 dias"
        width="190"
        sortable
      >
        <template slot-scope="scope">
          {{ scope.row.emUso ? "Sim" : "Não" }}
        </template>
      </el-table-column>

      <el-table-column prop="cliente" label="Grupo" min-width="80" sortable>
        <template slot-scope="scope">
          {{ scope.row.cliente }}
        </template>
      </el-table-column>

      <el-table-column
        prop="apelido"
        label="Apelido"
        min-width="80"
        width="240"
        sortable
      >
        <template slot-scope="scope">
          <div v-if="editingRow === scope.row && editingColumn === 'apelido'">
            <el-input
              size="mini"
              v-model="scope.row.apelido"
              @change="saveEditApelidoCentroCusto(scope.row)"
            ></el-input>
          </div>
          <div v-else>
            {{ scope.row.apelido || "—" }}
            <i
              class="el-icon-edit-outline edit-inline-cell"
              @click="editInline(scope.row, 'apelido')"
            ></i>
          </div>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
      v-if="totalDeRegistros > 0"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :page-sizes="[25, 50, 75, 100]"
      :page-size="filters.pageSize"
      :current-page.sync="filters.page"
      layout="sizes, prev, pager, next"
      background
      class="text-center"
      :total="totalDeRegistros"
    >
    </el-pagination>
  </div>
</template>

<script>
export default {
  name: "CentrosCustosTable",
  props: {
    centrosCustosResponse: {
      type: Object,
      required: true
    },
    filters: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      editingRow: null,
      editingColumn: null
    };
  },
  computed: {
    totalDeRegistros() {
      return this.centrosCustosResponse.total || 0;
    }
  },
  methods: {
    handleSizeChange(val) {
      this.filters.pageSize = val;
      this.filters.page = 1;
      this.$emit("modelAlterado", this.filters);
    },
    handleCurrentChange(val) {
      this.filters.page = val;
      this.$emit("modelAlterado", this.filters);
    },
    sortChange(val) {
      this.filters.sort = val.prop;
      this.filters.order = val.order;
      // Descomente se quiser que dispare pesquisa automaticamente ao ordenar
      // this.$emit('modelAlterado', this.filters);
    },
    editInline(row, column) {
      row._originalApelido = row.apelido;
      this.editingRow = row;
      this.editingColumn = column;
    },
    async saveEditApelidoCentroCusto(row) {
      console.log("Editando centro de custo:", this.editingRow);

      let body = {
        CentroDeCustoId: this.editingRow.id,
        Apelido: this.editingRow.apelido
      };

      try {
        const request = await this.axios.post(
          this.$urls.EDITAR_CENTROS_CUSTOS_APELIDO,
          body
        );

        if (request.status === 202) {
          this.$message.error(request.data.message);

          const originalApelido = this.editingRow._originalApelido;
          row.apelido = originalApelido;
          this.editingRow.apelido = originalApelido;

          delete this.editingRow._originalApelido;
          this.editingRow = null;
          this.editingColumn = null;

          return;
        } else if (request.status !== 200) {
          this.$message.error(
            "Algum erro interno aconteceu, por favor consulte nosso suporte."
          );

          const originalApelido = this.editingRow._originalApelido;
          row.apelido = originalApelido;
          this.editingRow.apelido = originalApelido;

          delete this.editingRow._originalApelido;
          this.editingRow = null;
          this.editingColumn = null;

          return;
        }

        delete this.editingRow._originalApelido;
        this.editingRow = null;
        this.editingColumn = null;

        this.$notify({
          type: "success",
          title: "Centro de Custo Editado",
          dangerouslyUseHTMLString: true,
          message: "Apelido atualizado com sucesso"
        });
      } catch (error) {
        console.error("Erro ao editar centro de custo:", error);
        this.$message.error("Erro ao salvar alterações");

        if (this.editingRow && this.editingRow._originalApelido !== undefined) {
          const originalApelido = this.editingRow._originalApelido;
          row.apelido = originalApelido;
          this.editingRow.apelido = originalApelido;
        }

        if (this.editingRow) {
          delete this.editingRow._originalApelido;
        }
        this.editingRow = null;
        this.editingColumn = null;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.edit-inline-cell {
  float: right;
  cursor: pointer;
  font-size: 15px;
  position: relative;
  top: 4px;
  color: #007bff;
  transition: 0.2s;
  &:hover {
    color: #606266;
  }
}
</style>
